import { Hub } from 'aws-amplify';
import * as auth from '@webapp/sdk/auth';
import { Dispatch } from 'redux';
import * as actionCreators from './action-creators';

export const setupAmplifyIntegration = (dispatch: Dispatch) => {
  const listener = (data: any) => {
    switch (data.payload.event) {
      case 'signIn':
        dispatch(new actionCreators.LoginUserSuccessRecently());
        dispatch(new actionCreators.LoginUserSuccess(data.payload.data));
        break;
      case 'tokenRefresh':
        dispatch(new actionCreators.UpdateTokenData());
        break;
      case 'signIn_failure':
        dispatch(new actionCreators.LoginUserError(data.payload.data.code));
        break;
      case 'signUp':
        dispatch(
          new actionCreators.CreateAccountSuccess(data.payload.data.user)
        );
        break;
      case 'signUp_failure':
        dispatch(new actionCreators.CreateAccountError(data.payload.data.code));
        break;
      case 'signOut':
        dispatch(new actionCreators.LogoutUserSuccess());
        break;
      case 'signOut_failure':
        dispatch(new actionCreators.LoginUserError(data.payload.data.code));
        break;
      case 'customState_failure':
        dispatch(new actionCreators.GoogleLoginUserError('AUTH.USER_EXISTS'));
        break;
      case 'configured':
        auth.getUser().then((user) => {
          if (user) {
            return dispatch(new actionCreators.LoginUserSuccess(user));
          }

          return dispatch(new actionCreators.LogoutUserSuccess());
        });
        break;
    }
  };

  Hub.listen('auth', listener);
};

export default setupAmplifyIntegration;
